export default __webpack_public_path__ + "static/media/138.892d9cb8.jpg";